var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconStorygameGuideMenu = function SvgIconStorygameGuideMenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#icon_storygame_guide_menu_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon_storygame_guide_menu_svg__b)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 20,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#101010"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33 34h14m-14 6h14m-14 6h14",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 20.75,
    y: 20.75,
    width: 38.5,
    height: 38.5,
    rx: 19.25,
    stroke: "#fff",
    strokeOpacity: 0.25,
    strokeWidth: 1.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon_storygame_guide_menu_svg__b"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 20,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "icon_storygame_guide_menu_svg__a",
    x: 0,
    y: 0,
    width: 80,
    height: 80,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3813_80039"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_3813_80039",
    result: "shape"
  })))));
};
export default SvgIconStorygameGuideMenu;